document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".collection-grid-wrapper");
    if (!wrapper) return;
  
    // Function to handle the layout
    function handleLayout() {
      const isMobile = window.innerWidth <= 480;
  
      if (isMobile) {
        // Store the title element
        const titleElement = wrapper.querySelector(".collection-title");
  
        // Create two rows from existing items
        const items = Array.from(wrapper.querySelectorAll(".col"));
        const totalItems = items.length;
        const itemsPerRow = 4; // 4 items per row
  
        // Clear existing content except title
        if (titleElement) {
          wrapper.innerHTML = "";
          wrapper.appendChild(titleElement);
        } else {
          wrapper.innerHTML = "";
        }
  
        // Create scroll container
        const scrollContainer = document.createElement("div");
        scrollContainer.style.overflowY = "auto";
        scrollContainer.style.height = "395px";
  
        // Create first row
        const firstRow = document.createElement("div");
        firstRow.className = "row";
        firstRow.style.display = "flex";
        firstRow.style.flexWrap = "wrap";
        firstRow.style.marginBottom = "0";
  
        // Create second row
        const secondRow = document.createElement("div");
        secondRow.className = "row";
        secondRow.style.display = "flex";
        secondRow.style.flexWrap = "wrap";
        secondRow.style.gap = "15px";
  
        // Distribute items between rows
        items.forEach((item, index) => {
          if (index < itemsPerRow) {
            firstRow.appendChild(item);
          } else {
            secondRow.appendChild(item);
          }
        });
  
        // Add rows to scroll container
        scrollContainer.appendChild(firstRow);
        scrollContainer.appendChild(secondRow);
  
        // Add scroll container to wrapper
        wrapper.appendChild(scrollContainer);
  
        // Add custom scrollbar styles
        const style = document.createElement("style");
        style.textContent = `
          .collection-grid-wrapper > div::-webkit-scrollbar {
            height: 4px;
          }
          .collection-grid-wrapper > div::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          .collection-grid-wrapper > div::-webkit-scrollbar-thumb {
            background: var(--color-primary);
            border-radius: 4px;
          }
        `;
        document.head.appendChild(style);
      } else {
        // Restore original layout for larger screens
        const originalContent = wrapper.getAttribute("data-original-content");
        if (originalContent) {
          wrapper.innerHTML = originalContent;
        }
      }
    }
  
    // Store original content before any modifications
    if (!wrapper.getAttribute("data-original-content")) {
      wrapper.setAttribute("data-original-content", wrapper.innerHTML);
    }
  
    // Initial call
    // handleLayout();
  
    // Add resize listener
    //window.addEventListener("resize", handleLayout);
  });
  